import { injectIntl, defineMessages } from "react-intl";
import { useFormatMessage } from "../Intl/Context";

const PageNotFound = () => {
  const t = useFormatMessage();
  const title = t(intlMessages.title);
  const description = t(intlMessages.description, { p: message => `<p>${message}</p>` });

  return (
    <div className="container padding-xl box">
      <h1 className="text-title-section margin-bottom-md">{title}</h1>

      <div className="text-default" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default injectIntl(PageNotFound);

const intlMessages = defineMessages({
  title: {
    id: "main.error.pageNotFound.title",
    defaultMessage: "La page demandée n'existe pas."
  },
  description: {
    id: "main.error.pageNotFound.description",
    defaultMessage: `
      <p>
        Il semblerait que la page que vous souhaitez charger n'existe pas. Le lien qui 
        vous a amené ici n'a pas du être mis à jour suite à la suppression de la page.
      </p>
      <p>
        Vous pouvez utiliser le menu principal pour retourner sur la plateforme.
      </p>
    `
  }
});
